import http from 'plugins/axios';

export default {
  getBannerList(data) {
    return http.post({
      url: '/admin/v2/banner/list',
      data,
      dataType: 'form'
    });
  },
  getNoticeList(params) {
    return http.get({
      url: '/admin/v2/banner/noticeList?page=' + params.page + '&size=' + params.size,
      dataType: 'form'
    });
  },
  getBannerDetail(id) {
    return http.get({
      url: `/admin/v2/banner/detail/${id}`
    });
  },
  getNoticeDetail(id) {
    return http.get({
      url: `/admin/v2/banner/noticeDetail/${id}`
    });
  },
  createBanner(data) {
    return http.post({
      url: '/admin/v2/banner/add',
      data,
      dataType: 'form'
    });
  },
  createNotice(data) {
    return http.post({
      url: '/admin/v2/banner/noticeCreate',
      data
    });
  },
  updateBanner(data) {
    return http.post({
      url: '/admin/v2/banner/update',
      data,
      dataType: 'form'
    });
  },
  updateNotice(data) {
    return http.post({
      url: '/admin/v2/banner/noticeUpdate',
      data
    });
  },
  removeBanner(id) {
    return http.get({
      url: `admin/v2/banner/delete/${id}`
    });
  },
  removeNotice(id) {
    return http.post({
      url: `admin/v2/banner/noticeRemove/${id}`
    });
  },
  noticeIsShelf(id, isShelf) {
    return http.post({
      url: `admin/v2/banner/noticeIsShelf/${id}/${isShelf}`
    });
  },
  updateSort(data) {
    return http.post({
      url: 'admin/v2/banner/sort',
      data,
      dataType: 'form'
    });
  }
};
